module.exports = __webpack_public_path__ + "img/icon-movie.23fcd862.svg";